import React, { useMemo } from 'react';
import BookingItem from './BookingItem';
import EventLabel from '../../../components/EventLabel/EventLabel';

export default function Bookings(props) {
  const {
    bookings,
    orders,
    eventId,
    displayEventSettings,
    currency,
    show,
    onBookingDelete,
    onBookingChange,
    onRoomChange,
    roomMates,
    selectRoomMateFromOrder,
    hideRegisterLater,
  } = props;

  const allRooms = useMemo(() => bookings?.reduce((acc, { rooms }) => [...acc, ...rooms], []), [bookings]);

  if (bookings?.length < 1) return null;
  return (
    <div className="bookings my-4">
      <div className="card-title flex-row items-flexstart md:items-center ">
        <div className="flex  items-center">
          <i className="ri-hotel-bed-line ri-lg mr-1 font-normal" />
          <h3 className="semi-bold">
            <EventLabel name="MyRoomsTitle" groupName="CMS.Hotel" />
          </h3>
        </div>
        <div>
          <h3 className="text-sm flex">
            <span className="hidden md:block">
              <EventLabel name="BookedRoomsCount" groupName="CMS.Hotel" />
            </span>{' '}
            <span className="ml-1">{bookings?.length}</span>
          </h3>
        </div>
      </div>
      <div className="card my-2 bg-[rgba(0,0,0,0.05)] p-0 md:p-6">
        {bookings?.map(
          (
            {
              hotel,
              orderRowId,
              vatPercent,
              hotelGroupId,
              rooms,
              comment,
              type,
              amount,
              orderId,
              imageUrl,
              supplementVatPercent,
              supplementPrice,
              dateRangeString,
              nights,
              description,
            },
            i
          ) => (
            <BookingItem
              key={i}
              imageUrl={imageUrl}
              orders={orders}
              orderRowId={orderRowId}
              hotel={hotel}
              description={description}
              comment={comment}
              displayEventSettings={displayEventSettings}
              eventId={eventId}
              hotelGroupId={hotelGroupId}
              rooms={rooms}
              show={show}
              supplementPrice={supplementPrice}
              supplementVatPercent={supplementVatPercent}
              vatPercent={vatPercent}
              price={amount}
              orderId={orderId}
              allRooms={allRooms}
              type={type}
              bookings={bookings}
              onBookingDelete={() => onBookingDelete(hotelGroupId)}
              currency={currency}
              onBookingChange={onBookingChange}
              onRoomChange={onRoomChange}
              dateRangeString={dateRangeString}
              nights={nights}
              hideRegisterLater={hideRegisterLater}
              roomMates={roomMates}
              selectRoomMateFromOrder={selectRoomMateFromOrder}
            />
          )
        )}
      </div>
    </div>
  );
}
